import { useApiStore } from "@finitless/shared/stores";
import {
  getWhiteLabelProject,
  getWhiteLabelApiUrl,
} from "@finitless/shared/lib";

export const initWhiteLabel = () => {
  const project = getWhiteLabelProject();
  const apiUrl = getWhiteLabelApiUrl();

  if (project) {
    useApiStore.getState().setApiConfig({
      project,
      ...(apiUrl ? { api: { url: apiUrl } } : {}),
    });
  } else if (apiUrl) {
    const { api } = useApiStore.getState();
    useApiStore.setState({ api: { ...api, url: apiUrl } });
  }
};

export default initWhiteLabel;
